import { Button } from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';

export default function PreviousPageButton({
  href,
  content,
}: {
  href: string;
  content: string;
}) {
  return (
    <Button
      pl={0}
      mt="-xs"
      mb="xs"
      component="a"
      href={href}
      leftSection={<IconChevronLeft color="gray" size={18} />}
      color="gray"
      variant="subtle"
      size="sm"
    >
      {content}
    </Button>
  );
}
